import notify from "../../../../funcs/ToastFuncs";

const shareTrackingToClipboard = ({
  vehNo,
  manufName,
  ownerName,
  lastTollName,
  lastTollTime,
  direction,
  lastUpdated,
  lat,
  lng,
}) => {
  let googleMapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
  googleMapUrl = googleMapUrl.replaceAll(" ", "");
  const message = `
  Vehicle Tracking Details for ${vehNo} 🚛
  📌 Last Location: ${lastTollName}
  ⏳ Toll Crossed Time: ${lastTollTime}
  🧭 Traveling ${direction}
  🌐 View on map: ${googleMapUrl}

  👤 Owner: ${ownerName}
  🏭 Manufacturer: ${manufName}
    
  🕒 Last Updated Time: ${lastUpdated}
  ✅ Authentis Verified
    `;

  navigator.clipboard
    .writeText(message.trim())
    .then(() => {
      notify("Tracking info copied to clipboard.", "success", true, 1000);
    })
    .catch((err) => {
      console.error("Failed to copy tracking details to clipboard: ", err);
    });
};

export default shareTrackingToClipboard;
